import styled from "styled-components";

export const Container = styled.div`
  color: var(--dark-grey);
  font-size: 12px;
  line-height: 14px;

  .ant-badge-status-dot {
    height: 8px;
    width: 8px;
  }
`;
